import get from 'immutable-less/transmute/get';
import { useQuery } from 'data-fetching-client';
import { GET_ALL_FRAMEWORK_FOLDERS, FRAMEWORK_FOLDERS_FIELDNAME } from 'automation-ui-management/queries/frameworkFolderQueries';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const FrameworkFolderName = ({
  id
}) => {
  const {
    data,
    loading
  } = useQuery(GET_ALL_FRAMEWORK_FOLDERS);
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const folders = get(FRAMEWORK_FOLDERS_FIELDNAME, data) || [];
  const folderByObjectId = folders.find(folderCrmObject => getPropertyValue(folderCrmObject, 'hs_object_id') === id);
  if (!folderByObjectId) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "folder"
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: getPropertyValue(folderByObjectId, 'hs_name', '')
  });
};
export default FrameworkFolderName;